import { IconButton } from '@mui/material';
import CustomTooltip from '../../../../components/card/CustomTooltip';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './Buttons.scss';

const defaultProps = {
  ariaLabel: '',
  onClick: () => null,
  disabled: false,
  icon: null,
  label: null,
};
const GenericButton = (props) => {
  const { ariaLabel, onClick, disabled, icon: Icon, label } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <CustomTooltip title={ariaLabel} aria-label={ariaLabel}>
      <span>
        <IconButton className='admin-action-icon-button' disabled={disabled} aria-label={ariaLabel} onClick={onClick}>
          <Icon />
        </IconButton>
        <span className='admin-action-icon-button-label'>{label}</span>
      </span>
    </CustomTooltip>
  );
};

export default GenericButton;
